import CharCreate from "../../_helper/charcreate";
import {s_char} from "../../_signals/s_char";
import {s_char_attr_step} from "../../_signals/s_char_attr";
import Grid from "@mui/material/Grid";
import CasinoIcon from "@mui/icons-material/Casino";
import ccAttribute from "../../_helper/ccAttribute";
import React from "react";
import {
    s_char_mods_cha,
    s_char_mods_ges,
    s_char_mods_str,
    s_char_mods_wah,
    s_char_mods_wil,
    s_char_mods_zae
} from "../../_signals/s_char_mods";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {rollerSetRoll} from "../../_helper/rollBehave";
import {displayAttributeModNSC} from "../../_helper/displayAttributeModNSC";
import TextField from "@mui/material/TextField";
import updChar from "../../_sig_api/updChar";
import {s_app_mobile} from "../../_signals/s_app";

type Props = {
    attribute: string;
};
export default function AttributeNSC({attribute}: Props) {

    const ccattr = CharCreate.attributes.filter(e => e.pfield === attribute).shift();
    let label = ccattr!.title+':';
    if (s_app_mobile.value) label = attribute.toUpperCase();

    const roll = (label, step, attr, canusekarma, karma) => {
        let step_mod = 0;
        if (attr === 'str') step_mod = s_char_mods_str.value
        if (attr === 'ges') step_mod = s_char_mods_ges.value
        if (attr === 'zae') step_mod = s_char_mods_zae.value
        if (attr === 'cha') step_mod = s_char_mods_cha.value
        if (attr === 'wah') step_mod = s_char_mods_wah.value
        if (attr === 'wil') step_mod = s_char_mods_wil.value
        const roll: IRollerRoll = {
            title: label,
            step: step,
            attribute: attr,
            step_mod: step_mod,
            canusekarma: canusekarma,
            karma: karma,
            strain: 0,
            vsnum: 0,
            vs:'',
            as: '',
            as_fix: false,
            target: [],
            targetVS:''
        }

        rollerSetRoll(roll,true);
    }

    return <>
        <Grid item xs={12} style={{textAlign: 'left'}}>
            <div style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
                    <div style={{fontSize: '1rem'}}>{label}</div>
                    <TextField InputLabelProps={{shrink: true}}
                               onChange={e => updChar([{k:attribute,v: parseInt(e.target.value)}])}
                               style={{marginLeft: 8, maxWidth: 80}}
                               defaultValue={s_char.value[attribute]}
                               variant="standard" type="number"/>
                    <div>{displayAttributeModNSC(attribute)}</div>

                <div style={{marginLeft: 'auto', display: 'flex'}}>
                    {s_char.value[attribute + '_k'] ?
                        <CasinoIcon
                            style={{color: 'red', margin: 10}}
                            onClick={() => roll(
                                ccAttribute(attribute, 'tt'),
                                s_char_attr_step(attribute),
                                attribute,
                                s_char.value[attribute + '_k'],
                                true
                            )}/> : null}
                    <CasinoIcon style={{margin: 10}}
                                onClick={() => roll(
                                    ccAttribute(attribute, 'tt'),
                                    s_char_attr_step(attribute),
                                    attribute,
                                    s_char.value[attribute + '_k'],
                                    false
                                )}/>
                </div>
            </div>
        </Grid>
    </>
}